// Preloader utility to load all sections in memory
export const preloadAllSections = () => {
  // Force browser to load and cache all section content
  const preloadPromises = [];
  
  // Only preload images that are actually used in initial render
  const imagesToPreload = [
    '/InitX_Logo.png'  // This is used in navbar - actually needed
    // Removed '/favicon.ico' - already preloaded in HTML
  ];
  
  imagesToPreload.forEach(src => {
    const img = new Image();
    img.src = src;
    preloadPromises.push(
      new Promise(resolve => {
        img.onload = resolve;
        img.onerror = resolve;
      })
    );
  });
  
  // Remove unused preload links - fonts are loaded via Google Fonts in HTML
  // Only add preloads for resources actually used during initial render
  
  // Force component rendering in memory
  const sectionsData = {
    services: true,
    projects: true,
    techStack: true,
    testimonials: true,
    trustSignals: true,
    pressReleases: true,
    ctaBanner: true,
    faq: true
  };
  
  // Store in sessionStorage to indicate preloading complete
  sessionStorage.setItem('sectionsPreloaded', JSON.stringify(sectionsData));
  
  return Promise.all(preloadPromises);
};

// Check if sections are already preloaded
export const areSectionsPreloaded = () => {
  return sessionStorage.getItem('sectionsPreloaded') !== null;
};

// Force immediate DOM rendering
export const forceRenderSections = () => {
  // Create invisible container to force component instantiation
  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.left = '-9999px';
  container.style.opacity = '0';
  container.style.pointerEvents = 'none';
  container.setAttribute('data-preload-container', 'true');
  
  document.body.appendChild(container);
  
  // Remove after brief delay
  setTimeout(() => {
    const preloadContainer = document.querySelector('[data-preload-container]');
    if (preloadContainer) {
      preloadContainer.remove();
    }
  }, 100);
};